module.exports = __webpack_public_path__ + "static/media/1017122.0c61ae07.png";